import { getDomainWithoutSubdomain } from './url';

export function setCookie(key, value, minutes) {
  const date = new Date();
  date.setTime(date.getTime() + minutes * 60 * 1000);
  const cookie = `${key}=${value};domain=.${getDomainWithoutSubdomain()};expires=${date.toGMTString()}`;
  document.cookie = cookie;
}
